import type { Person } from '$lib/types';
const key = 'crm-pending-call';
export function beginContactCall(person: Person, type = 'call'): void {
  try { sessionStorage.setItem(key, JSON.stringify({ personId: person.id, type, at: Date.now() })); } catch { /* Storage may be blocked. */ }
}
/** One prompt on returning focus, never an inferred call outcome. */
export function consumeContactCall(): { personId: number; type: string } | null {
  try {
    const raw = sessionStorage.getItem(key); sessionStorage.removeItem(key);
    if (!raw) return null;
    const value = JSON.parse(raw);
    return Date.now() - value.at < 86400000 ? value : null;
  } catch { return null; }
}
